module.exports = __webpack_public_path__ + "img/11.205d5983.png";